import { useNavigate } from "react-router-dom";
import ButtonComponent from "../../components/button/Button";
import EventComponent from "../../components/eventCard/EventComponent";

const UpcomingEvents = ({ adventures }) => {
  const navigate = useNavigate();

  return (
    <div className="mb-24 pt-24 px-4 sm:px-8">
      {/* Title and Button */}
      <div className="flex flex-col lg:flex-row justify-between items-start lg:items-center space-y-5 lg:space-y-0">
        <div className="flex-1">
          <div className="text-2xl sm:text-4xl lg:text-5xl text-color-primary-dark1 font-semibold">
            Upcoming Hikes
          </div>
        </div>

        <div
          className="w-full lg:w-auto flex justify-start lg:justify-end"
          onClick={() => navigate("/events")}
        >
          <ButtonComponent name={"View All"} type={"view"} />
        </div>
      </div>

      {/* Events Grid */}
      <div className="my-10 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6">
        {adventures && adventures.length > 0 ? (
          adventures.map((adventure, index) => (
            <div
              key={index}
              className="h-full cursor-pointer"
              onClick={() => navigate(`/events/${adventure.id}`)}
            >
              <EventComponent adventure={adventure} />
            </div>
          ))
        ) : (
          <div className="col-span-full text-center text-gray-500">
            No events
          </div>
        )}
      </div>
    </div>
  );
};

export default UpcomingEvents;
